import { render, staticRenderFns } from "./MetricsDashboard.vue?vue&type=template&id=56b0f1c2&scoped=true"
import script from "./MetricsDashboard.vue?vue&type=script&lang=ts"
export * from "./MetricsDashboard.vue?vue&type=script&lang=ts"
import style0 from "./MetricsDashboard.vue?vue&type=style&index=0&id=56b0f1c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b0f1c2",
  null
  
)

export default component.exports